export default "__VITE_ASSET__CSATPBlW__"